// extracted by mini-css-extract-plugin
export var backdropBlur = "_cf-0";
export var contentCard = "_cf-5";
export var frame = "_cf-2";
export var image = "_cf-4";
export var imagePane = "_cf-3";
export var modal = "_cf-1";